import React from "react";
import {
  form,
  Form as AppForm,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { onSuccess } from "LIB/submission";
import { connect } from "react-redux";
import { API_BASE } from "APP_ROOT/constants";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import { Button } from "react-bootstrap";

import { validatePartialCreditRequest } from "./validate";

export function Form(props) {
  const { close, handleSubmit, reset } = props;
  const onCancel = () => {
    close();
    reset();
  };
  const submit = onSuccess(handleSubmit, onCancel, props);

  return (
    <AppForm {...props} onSubmit={submit}>
      <AppForm.Body>
        <div className="row">
          <div className="col-md-6">
            <Field
              required
              name="partial_credit_amt"
              component={CurrencyField}
              label="Credit Amt"
            />
          </div>
        </div>
      </AppForm.Body>
      <AppForm.Footer>
        <Button onClick={close} type="button">
          Cancel
        </Button>
        <Button onClick={submit} className="btn btn-success">
          Download
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => {
    const url = `${API_BASE}/vendor_rmas/${ownProps.rma.get(
      "id"
    )}/download_partial_credit_request_document`;

    return dispatch(actions.download(data, url));
  }
}))(
  form({
    form: "rmaPartialCreditRequest",
    validate: validatePartialCreditRequest
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Actions/RequestPartialCreditForm.jsx